// extracted by mini-css-extract-plugin
export var container = "calendar-module--container--s7pET";
export var dateTime = "calendar-module--dateTime--KzzK9";
export var description = "calendar-module--description--Uzo+D";
export var location = "calendar-module--location--DLzE4";